import reducer from './reducers';

export { default as searchTileActions } from './actions';
export { default as searchTileSagas } from './sagas';
export * from './selectors';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/search-tile/index.js